import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../../firebase-config";
import { platformTool } from "../../utils/PlatformTool";
import { soulApi } from "../api/SoulApi";
import { SoulLoginParams } from "../models/Soul/SoulLoginParams";

class AuthManager {
  private static instance: AuthManager;
  private authReadyPromise?: Promise<string | undefined>;

  public static get(): AuthManager {
    if (!this.instance) {
      this.instance = new AuthManager();
    }
    return this.instance;
  }

  async login(email: string, password: string): Promise<boolean> {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      const deviceData = await platformTool.getDeviceData();
      const data: SoulLoginParams = {
        userId: user.uid,
        deviceData,
      };
      return this.sendLoginDataToBackend(data);
    } catch (error) {
      console.error("Error en login:", error);
      return false;
    }
  }

  async getAuthToken(): Promise<string | undefined> {
    if (auth.currentUser?.uid) {
      return auth.currentUser.uid;
    }

    if (!this.authReadyPromise) {
      this.authReadyPromise = new Promise((resolve) => {
        let unsubscribe = () => {};
        const timeoutId = window.setTimeout(() => {
          unsubscribe();
          this.authReadyPromise = undefined;
          resolve(undefined);
        }, 5000);

        unsubscribe = onAuthStateChanged(auth, (user) => {
          window.clearTimeout(timeoutId);
          unsubscribe();
          this.authReadyPromise = undefined;
          resolve(user?.uid);
        });
      });
    }

    return this.authReadyPromise;
  }

  async logout(): Promise<void> {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error en logout:", error);
    }
  }

  private async sendLoginDataToBackend(
    params: SoulLoginParams
  ): Promise<boolean> {
    const result = await soulApi.soulLogin.request(params);
    if (result.isSuccess) {
      return true;
    }
    return false;
  }
}

export const authManager = AuthManager.get();
